import React from 'react'

import './SourceOfData.scss'

const SourceOfData = () => {
  return (
    <div className="source-of-data-comp">
      <h4>Data Sources</h4>
      <div className="source">
        <a
          href="https://nces.ed.gov/ccd/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Common Core Data (CCD)
        </a>
        <div className="source-org">National Center for Education Statistics (NCES)</div>
      </div>
      <div className="source">
        <a
          href="https://nces.ed.gov/surveys/pss/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Private School Universe Survey (PSS)
        </a>
        <div className="source-org">National Center for Education Statistics (NCES)</div>
      </div>
    </div>
  )
}

export default SourceOfData
